import React from 'react';
import {getStoreByName} from 'client/framework';

import {CardList, CardListItem} from 'client/generic/CardList/CardList.react';
import LoadingIndicator from 'client/generic/LoadingIndicator.react';

import TeacherClassroomScope from '../../TeacherClassroomScope/TeacherClassroomScope.react';

import BestTopicsStore from './BestTopics/BestTopics.store';
import ToughestTopicsStore from './ToughestTopics/ToughestTopics.store';
import Topics from './Topics/Topics.react';
import topicsTableStore from './Topics.store';

import './student-topics.scss';
import './topic-guide-table.scss';

import Themes from './Table/Themes.react';
import SubjectLineItem from './Table/SubjectLineItem.react';

export default class StudentTopics extends React.Component {
  getToughestTopics() {
    const toughestStoreName = 'student-overview-topics-toughest-store';
    const store = getStoreByName(toughestStoreName)
      ? getStoreByName(toughestStoreName)
      : new ToughestTopicsStore(toughestStoreName);
    return (
      <CardListItem key={store.getName()}>
        <Topics heading='Toughest Three Topics' topicStore={store} />
      </CardListItem>
    );
  }

  getBestTopics() {
    const bestStoreName = 'student-overview-topics-best-store';
    const store = getStoreByName(bestStoreName)
      ? getStoreByName(bestStoreName)
      : new BestTopicsStore(bestStoreName);
    return (
      <CardListItem key={store.getName()}>
        <Topics heading='Best Three Topics' topicStore={store} />
      </CardListItem>
    );
  }

  getGuideTable() {
    if (!topicsTableStore.hasReceivedSubjects()) {
      return <LoadingIndicator />;
    }

    return (
      <div className='topic-table'>
        <div className='topic-table-row'>
          <div className='topic-table-row__cell--header topic-table-row__cell topic-table-row__cell--large'>
            Guide Level
          </div>
          <div className='topic-table-row__cell--header topic-table-row__cell'>Time Spent</div>
          <div className='topic-table-row__cell--header topic-table-row__cell topic-table-row__cell--medium'>
            Unique Questions Answered
          </div>
          <div className='topic-table-row__cell--header topic-table-row__cell'>
            Percent Complete
          </div>
          <div className='topic-table-row__cell--header topic-table-row__cell'>Accuracy</div>
          <div className='topic-table-row__cell--header topic-table-row__cell'>Mastery Level</div>
        </div>
        <ul className='guide-table-list-group'>
          {topicsTableStore.getSubjects().map((subject) => {
            /*
              We explicitly take the first here because subjects do not yet have > 1 guide.

              Intentionally not doing this in the model because I don't want this to be a future
              stealth bug.

              NOTE: Also being used in StudyGuideStore.js -- Update that too if you're changing this.
            */
            const guidesForSubject = subject.getGuides();
            return guidesForSubject.reduce((acc, guide) => {
              const themeList = guide.getSortedThemes();

              if (themeList.isEmpty()) {
                return acc;
              }

              acc.push(
                <>
                  <SubjectLineItem
                    guideType={guide.getGuideType()}
                    subject={subject}
                    key={guide.getId()}
                  />
                  <Themes themes={themeList} guide={guide} />
                </>
              );
              return acc;
            }, []);
          })}
        </ul>
      </div>
    );
  }

  render() {
    return (
      <div className='student-topics'>
        <TeacherClassroomScope className='student-topics-scope card' />
        <div className='student-topics-summary'>
          <CardList>
            {this.getBestTopics()}
            {this.getToughestTopics()}
          </CardList>
        </div>
        <div className='student-topics-guides'>{this.getGuideTable()}</div>
      </div>
    );
  }
}
